import EnumType from "./EnumType.js";

const values =  {
  Day: 0, 
  Night: 1
};

export default EnumType.generate(values, "Shift.");